import React from 'react';
import { useEffect, useReducer } from "react";
import styles from "./reviews-page.module.css";
import { useSelector } from "react-redux";
import { reviewsListSelector } from "../../Reducers/reviewsListReducer";
import { useDispatch } from "react-redux";
import { getReviewsList } from "../../Actions/reviewsListAction";
import LoadingSpinner from "../CommonComponents/loadingSpinner";
import { ReviewList } from "./ReviewList";
import ReviewsFilters from "./ReviewsFilters";
import { reducer, initialState, actions, responseViewOptions, useSetter } from "./reviewListReducer";
import { cx } from "../../Util/classHelpers";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";
import { companiesIdTokenSelector } from "../../Reducers/companiesIdTokenReducer";
import { getReviewChatRooms } from "../../Actions/reviewChatRoomsAction";
import { reviewChatRoomsSelector } from "../../Reducers/reviewChatRoomsReducer";
import { arraysEqual } from "../../Util/jsUtils";
import { getJwtToken } from "../../Util/localCache";

import { ShipdayChatModal } from "shipday-chat";
import { companyConfigurationsSelector } from '../../Reducers/companyConfigurtionsReducer';
import { plansSelector } from '../../Reducers/plansReducer';


export const REVIEWS = "REVIEWS";

const ReviewsPageWrapper = () => {
  const reviewsList = useSelector(reviewsListSelector);
  const { data: partnerAccounts } = useFetchCompanyInfosQuery();
  const signedToken = useSelector(companiesIdTokenSelector);
  const reviewChatRooms = useSelector(reviewChatRoomsSelector);
  const companyConfigs = useSelector(companyConfigurationsSelector);
  const plans = useSelector(plansSelector);
  const dispatch = useDispatch();

  const [state, reducerDispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch(getReviewsList(state.timeFrame));
  }, [state.timeFrame, dispatch]);

  useSetter(reviewsList, reducerDispatch, actions.SET_ALL_REVIEWS);
  useSetter(partnerAccounts, reducerDispatch, actions.SET_ALL_COMPANIES);
  useSetter(reviewChatRooms, reducerDispatch, actions.SET_REVIEW_CHAT_ROOMS);
  useSetter(companyConfigs, reducerDispatch, actions.SET_COMPANY_CONFIGS);
  useSetter(plans, reducerDispatch, actions.SET_PLANS);

  useEffect(() => {
    if (
      state.processedReviews &&
      state.processedReviews.length > 0 && 
      reviewChatRooms.hasRoomKeysChanged(state.reviewRoomKeys)
    ) {
      dispatch(getReviewChatRooms(state.reviewRoomKeys));
    }
  }, [state.processedReviews, dispatch]);

  useEffect(() => {
    if (state.refetchReviewRoomInfo) {
      dispatch(getReviewChatRooms(state.reviewRoomKeys));
    }
  }, [state.refetchReviewRoomInfo, dispatch]);

  const showLoading =
    reviewsList.getTimeframe() !== state.timeFrame;

  return (
    <div className={cx(styles.reviewsContainer, showLoading && "disabled-div")}>
      <div className={styles.reviewsHeader}>
        <div className={styles.reviewsTitle}>Reviews</div>
      </div>

      <div className={styles.filtersContainer}>
        <ReviewsFilters state={state} dispatch={reducerDispatch} />
      </div>

      {
        reviewsList.getTimeframe() === null ? (
          <></>
        ) : (
          <ReviewList state={state} dispatch={reducerDispatch} />
        )
      }

      {showLoading && (
        <div>
          <LoadingSpinner />
        </div>
      )}

      <ShipdayChatModal
        open={state.reviewOpened && state.responseView === responseViewOptions.FULL}
        onClose={() => reducerDispatch({ type: actions.CLOSE_RESPONSE_VIEW })}
        roomId={state.reviewRoomId}
        orderDetails={state.reviewOrderDetails}
        role="ENTERPRISE"
        signedToken={signedToken}
        reviewResponseTarget={state.targetReferenceId}
        token={getJwtToken()}
      />
    </div>
  );
};

export default ReviewsPageWrapper;
